/*
 * @Description:
 * @Author: jia.chen02
 * @Date: 2024-04-19 14:37:21
 * @LastEditors: jia.chen02
 * @LastEditTime: 2024-04-19 15:45:46
 */
import { defineStore } from "pinia";
import axios from "@/utils/request";

export interface TState {
  paymentOptionList: Array<any>;
  paymentMethodConfig: any;
}

export interface objInfo {
  [key: string]: any;
}

export const usePaymentStore = defineStore({
  id: "payment",
  state: (): TState => ({
    paymentOptionList: [],
    paymentMethodConfig: {},
  }),
  getters: {},
  actions: {
    updatePaymentOptionList(value: any) {
      this.paymentOptionList = value;
    },
    updatePaymentMethodConfig(value: any) {
      this.paymentMethodConfig = value;
    },
    async getPaymentOptionList() {
      const res: any = await axios.post(
        "/facade/sale/store/transaction/mode/list",
        {}
      );
      if (res.code === 0) {
        const paymentMethodConfig = { 0: "全部" } as any;
        // 正常情况下交易方式列表
        res?.data?.forEach((item: any) => {
          paymentMethodConfig[item?.id] = item.modeName;
        });
        const paymentOptionList = mapToList(paymentMethodConfig);
        this.updatePaymentOptionList(paymentOptionList);
        this.updatePaymentMethodConfig(paymentMethodConfig);
      }
    },
  },
});

const mapToList = (obj: objInfo) => {
  return Object.keys(obj).map((key: string) => {
    return {
      id: Number(key),
      nameCn: obj[key],
    };
  });
};
